import React from 'react'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom'
import { Switch } from 'react-router-dom'
import { addUrlProps, UrlQueryParamTypes } from 'react-url-query'
import { LiveList, LiveSettings, LiveGame } from '.'
import { CustomizedSnackbar } from '../../../containers'
import { MenuAppBar } from '../../../Parts/MenuAppBar'
import { LANGUAGE_SHORT_CODE } from '../../../constants'
import { WID } from '../../../constants/Language'
import { Word } from '../../../containers'
import * as api from '../../../actions/api'
import { useEffect } from 'react'

const urlPropsQueryConfig = {
  v:  { type: UrlQueryParamTypes.number },
  md: { type: UrlQueryParamTypes.string },
  op: { type: UrlQueryParamTypes.string },
  mv: { type: UrlQueryParamTypes.string },
  pb: { type: UrlQueryParamTypes.string },
  pw: { type: UrlQueryParamTypes.string },
  tr: { type: UrlQueryParamTypes.string },
  rc: { type: UrlQueryParamTypes.string },
  an: { type: UrlQueryParamTypes.number },
  mc: { type: UrlQueryParamTypes.string },
  mk: { type: UrlQueryParamTypes.string },
  tl: { type: UrlQueryParamTypes.string },
  bp: { type: UrlQueryParamTypes.string },
  wp: { type: UrlQueryParamTypes.string },
  gr: { type: UrlQueryParamTypes.string },
}

const mapStateToProps = (state, ownProps) => {
  const { auth0 } = state.authentication
  const { socket } = state.api.live
  return ({
    auth0,
    socket
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    init: () => {
      dispatch(api.live.init())
    },
  })
}

const Live = (props) => {
  useEffect(() => {
    if (props.auth0 && !props.socket) {
      props.init()
    }
  }, [props.auth0, props.socket])

  var regstr = Object.keys(LANGUAGE_SHORT_CODE).map(key => LANGUAGE_SHORT_CODE[key]).join('|')

  return (
    <React.Fragment>
      <MenuAppBar title={<Word wid={WID.MENU_APP_BAR.LIVE}/>}/>
      <Switch>
        <Route exact path={`/:language(${regstr})/live`} component={LiveList}/>
        <Route exact path={`/:language(${regstr})/live/settings`} component={LiveSettings}/>
        <Route exact path={`/:language(${regstr})/live/:id`} component={addUrlProps({ urlPropsQueryConfig })(LiveGame)}/>

        <Route exact path='/live' component={LiveList} />
        <Route exact path='/live/settings' component={LiveSettings} />
        <Route exact path='/live/:id' component={addUrlProps({ urlPropsQueryConfig })(LiveGame)} />
      </Switch>
      <CustomizedSnackbar/>
    </React.Fragment>
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Live)



// WEBPACK FOOTER //
// ./src/Pages/Live/containers/LiveRouting.js